<template>
  <div
    class="w-full h-fit px-[28px] py-[20px] custom-936:flex custom-1200:flex custom-936:py-0 custom-xl:py-0 custom-xl:flex flex-row items-center justify-between bg-white border border-grays-400 rounded hover:shadow-cards_hover custom-xl:gap-1 gap-[36px]"
  >
    <div
      class="flex-none custom-936:flex custom-1200:flex custom-xl:flex flex-row gap-[28px]"
    >
      <title-section :title="$saleName(notCollectedOrder)" />
      <!-- <div class="w-fit flex flex-none flex-row items-center">
        <div class="h-[36px] w-[36px] rounded-full bg-complementary-600 flex-none ml-[8px] flex items-center justify-center p-[9px]">
          <icon-mishnat></icon-mishnat>
        </div>
        <div class="w-[152px] flex flex-col">
          <h2 class="font-bold text-custom-xl text-complementary-900 overflow-hidden truncate ">{{notCollectedOrder.parent.week}}</h2>
          <p class="font-regular text-sm text-complementary-900 mt-[-5px]"> המכירה השבועית תשפ"ג</p>
        </div>
      </div> -->
      <div
        class="flex-none custom-936:flex custom-1200:flex custom-xl:flex flex-row gap-[20px] custom-xl:gap-[40px] py-[11px]"
      >
        <div class="flex flex-none flex-col w-[140px] justify-between">
          <div>
            <p class="text-sm font-medium text-grays-600">יום איסוף</p>
            <p
              class="custom-936:text-[15px] custom-xl:text-[15px] 2xl:text-base font-regular text-grays-900"
            >
              {{ moment(notCollectedOrder.collection_day).format("dddd") }}
            </p>
            <p
              class="custom-936:text-[15px] custom-1200:flex xl:text-[15px] 2xl:text-base font-regular text-grays-900"
            >
              {{ jDate(notCollectedOrder.collection_day) }}
              {{ moment(notCollectedOrder.collection_day).format("DD/MM/Y") }}
            </p>
          </div>
          <div
            v-if="notCollectedOrder.sale.day_diff"
            class="bg-error text-white text-sm font-medium px-[8px] py-[3px] rounded my-2 lg:my-0 inline-block"
          >
            <span class="material-symbols-rounded text-xs">error</span>
            שינוי ביום
          </div>
        </div>
        <div
          v-if="
            (notCollectedOrder.times.split('|')[0] &&
              !notCollectedOrder.times
                .split('|')[0]
                .toString()
                .includes('00:00-00:00')) ||
            !notCollectedOrder.times
              .split('|')[1]
              .toString()
              .includes('00:00-00:00')
          "
          class="flex flex-none flex-col w-[140px] justify-between"
        >
          <div>
            <p class="text-sm font-medium text-grays-600">שעה</p>
            <div
              v-if="
                !notCollectedOrder.times
                  .split('|')[0]
                  .toString()
                  .includes('00:00-00:00')
              "
            >
              {{ notCollectedOrder.times.split("|")[0] }}
            </div>
            <div
              v-if="
                notCollectedOrder.times.split('|')[1] &&
                !notCollectedOrder.times
                  .split('|')[1]
                  .toString()
                  .includes('00:00-00:00')
              "
            >
              {{ notCollectedOrder.times.split("|")[1] }}
            </div>
          </div>
          <div
            v-if="notCollectedOrder.sale.time_diff"
            class="bg-error text-white text-sm font-medium px-[8px] py-[3px] rounded my-2 lg:my-0 inline-block"
          >
            <span class="material-symbols-rounded text-xs">error</span>
            שינוי בשעה
          </div>
        </div>
        <!-- Location -->
        <location-section
          :address="notCollectedOrder.site.address_description"
          :sale="notCollectedOrder"
          :street="notCollectedOrder.site.street"
          :city="notCollectedOrder.sale.site.city"
        />
      </div>
    </div>
    <div
      class="flex flex-col md:flex-row xl:justify-end gap-[8px] md:items-center flex-none"
    >
      <template
        v-if="
          notCollectedOrder.items.filter(
            (item) => item.amount === 0 && item.src_amount > 0
          ).length > 0
        "
      >
        <button-tooltip-icon-hayadata />

        <button-tooltip-error-hayadata
          :items="
            notCollectedOrder.items.filter(
              (item) => item.amount === 0 && item.src_amount > 0
            )
          "
          class="relative"
          @click="toggleTooltip"
        >
          <tooltip-user
            v-if="tooltipMissingProductId"
            class="absolute z-[60] top-[-190px] left-[15px] md:block hidden"
            direction="bottom"
            type="MissingProducts"
            @close="closeTooltip"
          />
          <span class="custom-936:hidden custom-1200:hidden custom-1382:hidden">
            מוצרים חסרים
          </span>
          <div
            v-if="isTooltipVisible"
            class="hidden custom-936:block custom-1200:block custom-1382:block absolute top-[43px] left-[0px] bg-error text-white p-2 w-[150px] h-[45px] border rounded-md"
          >
            <img
              alt="polygon red"
              class="top-[-9px] left-[10px] absolute w-[19px] h-[11px] m-auto"
              src="/src/assets/icons/global/polygon-red.svg"
            />
            <span> מוצרים חסרים </span>
          </div>
        </button-tooltip-error-hayadata>
      </template>
      <button-secondary @click="goToOrderDetails">לצפיה בהזמנה</button-secondary>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment/dist/locale/he";

import dayjs from "dayjs";
import "dayjs/locale/he";

import hebrewDate from "hebrew-date";
import ButtonTooltipIconHayadata from "@/components/Global/ButtonTooltipIconHayadata.vue";
import ButtonTooltipErrorHayadata from "@/components/Global/ButtonTooltipErrorHayadata.vue";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";
import TitleSection from "@/components/SalesBoard/TitleSection.vue";
import LocationSection from "@/components/SalesBoard/LocationSection.vue";
import { mapMutations } from "vuex";
import TooltipUser from "@/components/Tooltip/TooltipUser.vue";

export default {
  name: "strip-sale-to-be-taken",
  components: {
    TooltipUser,
    LocationSection,
    TitleSection,
    ButtonSecondary,
    ButtonTooltipErrorHayadata,
    ButtonTooltipIconHayadata,
  },
  props: {
    notCollectedOrder: {
      type: Object,
      required: true,
    },
    previousPage: {
      type: String,
      default: "/sales-board",
    },
    tooltipMissingProductId: {
      default: 0,
    },
  },
  data() {
    return {
      isTooltipVisible: false,
    };
  },
  methods: {
    closeTooltip() {
      this.$emit("closeTooltip");
    },
    toggleTooltip() {
      this.isTooltipVisible = !this.isTooltipVisible;
    },
    goToOrderDetails() {
      this.setPreviousPage(this.previousPage);
      this.$router.push(`/order/${this.notCollectedOrder.id}`);
    },
    ...mapMutations({
      setPreviousPage: "orderDetails/setPreviousPage",
    }),
    moment: function (param1, param2) {
      return moment(param1, param2);
    },
    jDate: function (date) {
      const months = [
        "תשרי",
        "חשוון",
        "כסליו",
        "טבת",
        "שבט",
        "אדר א",
        "אדר ב",
        "ניסן",
        "אייר",
        "סיון",
        "תמוז",
        "אב",
        "אלול",
      ];
      const days = [
        "א",
        "ב",
        "ג",
        "ד",
        "ה",
        "ו",
        "ז",
        "ח",
        "ט",
        "י",
        "יא",
        "יב",
        "יג",
        "יד",
        "טו",
        "טז",
        "יז",
        "יח",
        "יט",
        "כ",
        "כא",
        "כב",
        "כג",
        "כד",
        "כה",
        "כו",
        "כז",
        "כח",
        "כט",
        "ל",
      ];
      const years = {
        5781: "תשפ״א",
        5783: "תשפ״ג",
        5782: "תשפ״ב",
        5784: "תשפ״ד",
        5785: "תשפ״ה",
        5786: "תשפ״ו",
        5787: "תשפ״ז",
        5788: "תשפ״ח",
      };
      const y = Number(dayjs(date, "YYYY-MM-DD").format("YYYY"));
      // @ts-ignore
      const m = dayjs(date, "YYYY-MM-DD").format("M") - 1;
      const d = Number(dayjs(date, "YYYY-MM-DD").format("D"));
      // const day = dayjs(date, "YYYY-MM-DD").locale('he').format("dddd");
      // @ts-ignore
      return (
        days[hebrewDate(new Date(y, m, d)).date - 1] +
        " " +
        months[hebrewDate(new Date(y, m, d)).month - 1]
      );
    },
  },
};
</script>

<style scoped>
</style>